import { Building2, Car, Cog, Droplets, Factory, Flame, FlaskConical, Fuel, Settings, Ship, TrainFront, Wrench, Zap, Wheat, Wind, ThermometerSnowflake, Scissors, Hammer, FileText } from "lucide-react";
import * as Icons from "lucide-react";

/** Icons offered in Admin → Industries (the name is what is stored in the record's `icon`). */
export const INDUSTRY_ICON_NAMES = [
  "Factory", "Wheat", "ThermometerSnowflake", "FlaskConical", "Droplets", "Fuel", "Zap", "Ship", "Flame", "Car", "TrainFront", "Pill",
  "FileText", "Scissors", "Hammer", "Wind", "Wrench", "Cog", "Building2", "Settings",
];

// Only used when a record has no (valid) icon of its own: the icon that best matches the industry's name.
const ICON_BY_NAME = [
  [/sugar|food/i, Wheat],
  [/hvac|chiller|cooling/i, ThermometerSnowflake],
  [/distill/i, FlaskConical],
  [/solvent/i, Droplets],
  [/oil field|pipeyard|oil|gas/i, Fuel],
  [/power|energy|electric/i, Zap],
  [/ship|marine|offshore/i, Ship],
  [/steel|metal|foundry/i, Flame],
  [/automotive|vehicle/i, Car],
  [/rail/i, TrainFront],
  [/petro|chemical|pharma/i, FlaskConical],
  [/refiner/i, Factory],
  [/pulp|paper/i, FileText],
  [/textile/i, Scissors],
  [/machine shop/i, Hammer],
  [/process|boiler|heat exchanger|condenser/i, Wind],
  [/manufactur/i, Factory],
  [/maintenance/i, Wrench],
  [/engineer/i, Cog],
  [/cement|construction/i, Building2],
  [/water/i, Droplets],
];

// The icon chosen in Admin → Industries is authoritative; the name-based match is only the fallback for a record without one.
export function industryIcon(nameOrItem) {
  const isItem = nameOrItem && typeof nameOrItem === "object";
  const stored = isItem ? nameOrItem.icon : null;
  if (stored && Icons[stored]) return Icons[stored];
  const name = isItem ? nameOrItem.name || nameOrItem.title || "" : String(nameOrItem || "");
  const hit = ICON_BY_NAME.find(([re]) => re.test(name));
  return hit ? hit[1] : Settings;
}
